import { AppState } from '../../core/redux/rootReducer';

const isMessagingEnabled = (state: AppState): boolean => state.environment.messagingSettings.isMessagingEnabled;

const invoiceAsPaymentNotification = (state: AppState): boolean => state.environment.invoiceAsPaymentNotification;

const landLordName = (state: AppState): string => state.environment?.messagingSettings?.displayName ?? '';

export const environmentSelectors = { isMessagingEnabled, invoiceAsPaymentNotification, landLordName };
